import { Link } from "react-router-dom";
import ContactForm from "@/pages/contact/components/ContactForm";
import { useSeo } from "@/hooks/useSeo";

const contactInfo = [
  {
    icon: "ri-phone-line",
    label: "联系电话",
    value: "+886 2 1234 5678",
    href: "tel:+886212345678",
  },
  {
    icon: "ri-mail-line",
    label: "电子邮箱",
    value: "hello@taipeinana.com",
    href: "mailto:hello@taipeinana.com",
  },
  {
    icon: "ri-map-pin-line",
    label: "办公地址",
    value: "台北市信义区松高路 88 号 12 楼",
    href: "https://maps.google.com/?q=台北市信义区",
  },
  {
    icon: "ri-time-line",
    label: "服务时间",
    value: "周一至周五 10:00 - 18:30",
  },
];

export default function ContactPage() {
  useSeo({
    title: "联系我们 - 台北娜娜",
    description:
      "联系台北娜娜，获取品牌合作、内容咨询或读者服务。欢迎通过电话、邮箱或在线留言表单与我们取得联系。",
    keywords: "台北娜娜,联系我们,品牌合作,读者服务,联系方式",
  });

  return (
    <div>
      <section className="relative overflow-hidden bg-primary-900 text-background-50">
        <img
          src="https://readdy.ai/api/search-image?query=minimal%20modern%20office%20reception%20space%20with%20warm%20wood%20and%20soft%20lighting%2C%20neutral%20tones%2C%20editorial%20architecture%20photography&width=1920&height=900&seq=contact-hero-2026&orientation=landscape"
          alt="台北娜娜办公空间"
          title="联系我们 - 台北娜娜"
          className="absolute inset-0 h-full w-full object-cover object-top opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/70 to-primary-950/40" />
        <div className="relative px-4 pb-14 pt-28 md:px-8 md:pb-16 md:pt-32 lg:px-12">
          <nav className="flex items-center gap-2 text-xs text-background-50/60">
            <Link to="/" className="cursor-pointer transition-colors hover:text-background-50">
              首页
            </Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-background-50">联系我们</span>
          </nav>
          <h1 className="mt-5 font-heading text-3xl font-extrabold md:text-4xl">联系我们</h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-50/80 md:text-base">
            无论是品牌合作、内容咨询还是读者反馈，我们都很乐意听到你的声音。
          </p>
        </div>
      </section>

      <section className="bg-background-50 px-4 py-14 md:px-8 md:py-16 lg:px-12">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {contactInfo.map((item) => (
            <div key={item.label} className="rounded-2xl border border-background-200 bg-background-100 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className={`${item.icon} text-2xl`} />
              </span>
              <p className="mt-5 text-xs font-medium uppercase tracking-wider text-foreground-400">
                {item.label}
              </p>
              {item.href ? (
                <a
                  href={item.href}
                  target={item.href.startsWith("http") ? "_blank" : undefined}
                  rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined}
                  className="mt-2 block cursor-pointer text-sm font-medium leading-relaxed text-foreground-900 transition-colors hover:text-primary-600"
                >
                  {item.value}
                </a>
              ) : (
                <p className="mt-2 text-sm font-medium leading-relaxed text-foreground-900">{item.value}</p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.05fr] lg:gap-12">
          <div>
            <div className="overflow-hidden rounded-2xl border border-background-200">
              <iframe
                title="台北娜娜办公地址地图"
                aria-label="台北娜娜办公地址地图"
                src="https://maps.google.com/maps?q=%E5%8F%B0%E5%8C%97%E5%B8%82%E4%BF%A1%E4%B9%89%E5%8C%BA&t=&z=14&ie=UTF8&iwloc=&output=embed"
                className="h-[320px] w-full md:h-[440px]"
                loading="lazy"
              />
            </div>
            <div className="mt-5 rounded-2xl border border-background-200 bg-background-100 p-6">
              <h2 className="font-heading text-lg font-bold text-foreground-950">到访提示</h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                如需到访洽谈，请提前通过电话或邮箱预约。办公时间为周一至周五 10:00 - 18:30，节假日休息。
              </p>
            </div>
          </div>

          <ContactForm />
        </div>
      </section>
    </div>
  );
}